import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "¿Cuánto tarda el proceso?",
    a: "Entre 3 y 6 semanas desde la primera reunión hasta la entrega en España. El tiempo depende de la disponibilidad del modelo concreto, la negociación y los trámites de matriculación.",
  },
  {
    q: "¿Puedo importar una furgoneta?",
    a: "Sí. Gestionamos furgonetas comerciales (Sprinter, Crafter, Transit, Vito) y furgonetas de uso particular o camperizadas. Acompañamos también en el cumplimiento normativo en España.",
  },
  {
    q: "¿Revisáis el vehículo antes de comprar?",
    a: "Sí, siempre. Hacemos una inspección técnica y mecánica en persona antes de cualquier transferencia. Recibirás un informe detallado con fotos y vídeo del vehículo y del taller.",
  },
  {
    q: "¿Gestionáis la documentación?",
    a: "Sí. Nos encargamos del contrato de compraventa, documentación aduanera, ITV, homologación si procede, matriculación española e impuestos. Tú solo recibes el coche listo para circular.",
  },
  {
    q: "¿Me ayudáis a elegir el vehículo?",
    a: "Por supuesto. Esa es una de las partes clave de nuestro servicio. Te asesoramos sobre marca, modelo, motorización, equipamiento y año en función de tu uso y presupuesto.",
  },
  {
    q: "¿El proceso es transparente?",
    a: "Totalmente. Verás cada anuncio que evaluamos, cada presupuesto, cada documento. No cobramos comisiones ocultas ni trabajamos con concesionarios bajo cuerda.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      className="relative py-24 sm:py-32 bg-[#0A0A0A] border-t border-white/5"
      data-testid="faq-section"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <span className="text-xs uppercase tracking-[0.32em] text-[#D4AF37]">Preguntas frecuentes</span>
          <h2 className="font-heading mt-6 text-3xl sm:text-5xl font-light tracking-tight text-[#FFFFF0] leading-tight">
            Resolvemos tus dudas.
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-2">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] transition-colors data-[state=open]:border-[#D4AF37]/40 px-6"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-heading text-base sm:text-lg font-medium text-[#FFFFF0] py-6 hover:text-[#D4AF37] hover:no-underline text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-[#A3A3A3] leading-relaxed font-light pb-6 pr-8">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
